import { ComponentRoute } from '@/classes'

const SuperadminCompanyRoutes = {
  CompanyListView: new ComponentRoute('/superadmin/company/list', 'SuperadminCompanyListView'),
  CompanyView: new ComponentRoute('', 'SuperadminCompanyView'),
  CompanyDetail: new ComponentRoute('/superadmin/company/:companyId/detail/:companyType?', 'SuperadminCompanyDetail'),
  CompanyLicense: new ComponentRoute('/superadmin/company/:companyId/license/:companyType?', 'SuperadminCompanyLicense'),
  CompanyModules: new ComponentRoute('/superadmin/company/:companyId/modules/:companyType?', 'SuperadminCompanyModules'),
  CompanyItemCategory: new ComponentRoute('/superadmin/company/:companyId/itemcategory/:companyType?', 'SuperadminCompanyItemCategory'),
  CompanyExternal: new ComponentRoute('/superadmin/company/:companyId/:companyType?/external', 'SuperadminCompanyExternal'),
  CompanyNewUser: new ComponentRoute('/superadmin/company/:companyId/:companyType?/newuser', 'SuperadminCompanyNewUser'),
  CompanyUserListView: new ComponentRoute('/superadmin/company/users/:companyId', 'SuperadminCompanyUserListView')
}

export default SuperadminCompanyRoutes
